import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewEmployeeeComponent } from './new-employee.component'; 

//input de ubicacion
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { DxFilterBuilderModule, DxAccordionModule, DxFileUploaderModule, DxDropDownButtonModule, DxButtonGroupModule, DxAutocompleteModule, DxContextMenuModule, DxDropDownBoxModule, DxGanttModule, DxPopupModule, DxRadioGroupModule, DxSchedulerModule, DxScrollViewModule, DxSelectBoxModule, DxSliderModule, DxTabPanelModule, DxTextBoxModule, DxTreeViewModule, DxDataGridModule, DxTagBoxModule, DxDateBoxModule, DxCheckBoxModule, DxButtonModule, DxNumberBoxModule, DxValidatorModule } from 'devextreme-angular';
import { DxTextAreaModule } from 'devextreme-angular';
import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
import {
  DxFormModule, 
} from 'devextreme-angular';
@NgModule({
  declarations: [
    NewEmployeeeComponent
  ],
  imports: [
    CommonModule,
    MdbGlobalModule,
    GooglePlaceModule,
    DxAccordionModule,
    DxFilterBuilderModule,
    DxFileUploaderModule,
    DxDropDownButtonModule,
    DxButtonGroupModule,
    DxAutocompleteModule,
    DxContextMenuModule,
    DxDropDownBoxModule,
    DxGanttModule,
    DxPopupModule,
    DxRadioGroupModule,
    DxSchedulerModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxSliderModule,
    DxTabPanelModule,
    DxTextBoxModule,
    DxTreeViewModule,
    DxDataGridModule,
    DxTagBoxModule,
    DxDateBoxModule,
    DxCheckBoxModule,
    DxButtonModule,
    DxNumberBoxModule,
    DxValidatorModule,
    DxTextAreaModule,
    DxFormModule, 
  ],
  exports: [NewEmployeeeComponent]
})
export class NewEmployeeModule { }
